// extracted by mini-css-extract-plugin
export default {"logoPreviewContainer":"EditClientThemeDialog_logoPreviewContainer__1eMpf","logoPreview":"EditClientThemeDialog_logoPreview__getK8","hidden":"EditClientThemeDialog_hidden__nrekK"};